import Area from './seating/Area'
import ArenaImage from './seating/ArenaImage'
import LockedTickets from './Locked'
import {setupLockedTickets} from './Locked'

export default class TicketOptions {
    constructor() {
        this.el = $('.ticket-options')
        const locked = setupLockedTickets(this.onTicketsAdded.bind(this));
        
        this.locked = locked || {count: () => 0};
        
        if (!this.locked && (!this.locked || this.locked.count() === 0)) {
            return false;
        }
        
        this.seatOptions = []
        this.totalCount = 0
        this.update = this.update.bind(this)
        this.onFindTickets = this.onFindTickets.bind(this)
        this.codeRequired = this.el.data('code-required');
        this.getCodeRequired = this.getCodeRequired.bind(this);
        this.campaignRemainingTickets = parseInt( this.el.data('campaign-remaining-tickets')); //If null then ignore using it
        this.getTotalCount = this.getTotalCount.bind(this);
        this.init()
    }
    init() {
        $('.loader').hide();
        
        const context = this
        $('.seat-option').each(function () {
            let so = new SeatOption($(this), context.update, context.getCodeRequired(), context.getTotalCount)
            context.seatOptions.push(so)
        })
        this.findTicketsNum = $('.find-tickets .num')
        this.findTicketsButton = $('.find-tickets .btn-find-tickets')
        this.findTicketsButton.on('click', this.onFindTickets)

        this.continueButton = $('.continue .btn-continue')
        this.continueButton.on('click', this.onFindTickets)
        this.campaignTicketsRemainingExceeded = $('.campaign-tickets-remaining-exceeded');
    }
  update() {
        let maxData = [];
        let y = this.seatOptions.length
        while (y--) {
          let so = this.seatOptions[y]
          if (maxData[so.tickettemplateid] > 0) {
            maxData[so.tickettemplateid] = maxData[so.tickettemplateid] + so.getCurrentTotalNumSelectedTickets();
          } else {
            maxData[so.tickettemplateid] = so.getCurrentTotalNumSelectedTickets();
          }
        }
        let y2 = this.seatOptions.length
        while (y2--) {
          let so = this.seatOptions[y2];
          so.otherTicketCount = Math.max(0, maxData[so.tickettemplateid]);
        }

        let i = this.seatOptions.length
        this.totalCount = this.getTotalCount();
        this.findTicketsNum.text(this.totalCount)
        this.toggleFindTicketsButton()
    }
    toggleFindTicketsButton() {

        if (this.totalCount) {
            this.findTicketsButton.css('display', 'block');
            this.continueButton.css('display', 'none');
            this.campaignTicketsRemainingExceeded.css('display', 'none')
            if (this.campaignRemainingTickets !== NaN && this.totalCount > this.campaignRemainingTickets) {
                this.findTicketsButton.css('display', 'none')
                this.continueButton.css('display', 'none')
                this.campaignTicketsRemainingExceeded.css('display', 'block')
                return false;
            }
        } else {
            this.findTicketsButton.css('display', 'none')
            if ($('#selected-products li').length > 0) {
                this.continueButton.css('display', 'block')
            } else {
                this.continueButton.css('display', 'none')
            }
        }
    }
    onTicketsAdded(el) {
        const context = this
        $(el)
            .parents('.seat-option')
            .each(function () {
                let so = new SeatOption($(this), context.update, context.getCodeRequired(), context.getTotalCount)
                context.seatOptions.push(so)
            })
    }
    onFindTickets() {
        $('.loader').show()
        $('#ticket-form').submit()
        $('body').addClass('no-scroll')
        return false
    }

    getCodeRequired() {
        if (this.codeRequired === 'True') {
            return true;
        }
        else {
            return false;
        }
    }

    getTotalCount() {
        let i = this.seatOptions.length
        this.totalCount = 0
        while (i--) {
            let so = this.seatOptions[i]
            this.totalCount += so.getCurrentTotalNumSelectedTickets()
        }
        return this.totalCount;
    }
}

class SeatOption {
    constructor(el, cbUpdate, codeRequired, getTotalCount) {
        this.el = el
        this.cbUpdate = cbUpdate
        this.type = this.el.attr('data-type')
        this.tickettemplateid = this.el.attr('data-template')
        this.max = parseInt(this.el[0].dataset.max)
        this.min = parseInt(this.el[0].dataset.min)
        this.tickets = []
        this.codeRequired = codeRequired;
        this.getTotalCount = getTotalCount;
        this.getTotalNumSelectedTickets = this.getTotalNumSelectedTickets.bind(this)
        this.removeAllTickets = this.removeAllTickets.bind(this)
        this.init()
        this.otherTicketCount = 0;
    }
    init() {
      const context = this;
        this.el.find('.ticket').each(function () {
            let ticket = new Ticket(
                $(this),
                context.cbUpdate,
                context.max,
                context.min,
                context.getTotalNumSelectedTickets,
                context.removeAllTickets,
                context.codeRequired,
                context.getTotalCount
            )
            context.tickets.push(ticket)
        })
  }
    getTotalNumSelectedTickets() {
    return this.otherTicketCount;
  }
    getCurrentTotalNumSelectedTickets() {
        let i = this.tickets.length
        let total = 0
        while (i--) {
            let ticket = this.tickets[i]
            if (!ticket.getCount()) {
                continue
            }
            total += ticket.getCount()
        }
      return total;
    }
    setCurrentMax(max) {
      this.max = Math.min(max, this.el[0].dataset.max);
    }
    removeAllTickets() {
        for (const ticket of this.tickets) {
            ticket.count = 0
            ticket.render()
        }
  }

    getSelectedTickets() {
        let i = this.tickets.length
        let selectedTickets = []
        while (i--) {
            let ticket = this.tickets[i]
            if (!ticket.getCount()) {
                continue
            }
            selectedTickets.push({
                type: ticket.getType(),
                count: ticket.getCount()
            })
        }
        return selectedTickets.length ? selectedTickets : false
    }
}

class Ticket {
    constructor(
        el,
        cbUpdate,
        templateMax,
        templateMin,
        getTotalNumSelectedTickets,
        removeAllTickets,
        codeRequired,
        getTotalCount
    ) {
        this.el = el
        this.cbUpdate = cbUpdate
        this.interval = this.el.attr('data-interval')
        this.type = this.el.attr('data-type')
        this.code = this.el.attr('data-code')
        this.template = this.el.attr('data-tickettemplate')
        this.tickettemplateid = this.el.attr('data-template')
        this.min = this.el.attr('data-min')
        this.max = this.el.attr('data-max')
        this.templateMax = templateMax
        this.templateMin = templateMin
        this.count = 0
        this.templateTicketCount = getTotalNumSelectedTickets
        this.removeAllTickets = removeAllTickets
        this.codeRequired = codeRequired
        this.getTotalCount = getTotalCount
        this.render = this.render.bind(this)

        this.subtractNumTickets = this.subtractNumTickets.bind(this)
        this.addNumTickets = this.addNumTickets.bind(this)

        this.subtractButton = this.el.find('.selector .btn-step.subtract')
        this.addButton = this.el.find('.selector .btn-step.add')
        this.num = this.el.find('.selector .num')

        this.subtractButton.on('click', this.subtractNumTickets)
        this.addButton.on('click', this.addNumTickets)

        this.toggleDescription = this.toggleDescription.bind(this);
        this.descriptionSwitch = this.el.find('.description-switch');
        this.descriptionSwitch.on('click', this.toggleDescription);

        this.ticketDescription = this.el.find('.ticket-description');
    }
    subtractNumTickets() {
        const min = this.getMin()
        let ttCount = this.templateTicketCount()
        if (this.count > 0) {
          if (this.count <= min) {
            this.count = 0
          } else {
            this.count--
            if (this.interval > 1) {
              this.count = this.count - (this.interval - 1)
            }
            if (this.count <= min) this.count = min
          }
            if ((ttCount-1) < this.templateMin) {

            this.removeAllTickets()
          }
            ttCount = this.templateTicketCount()

        }
        if (this.count === 0) {
          this.ticketDescription.addClass("hidden");
        }
        this.render()
    }
    addNumTickets() {
        const max = this.getMax()
        const min = this.getMin()
        let ttCount = this.templateTicketCount()
        let totalCount = this.getTotalCount();
        let newValue = 0;
        if (ttCount !== this.templateMax) {
            if (this.count < min) {
                newValue = min
            } else {
                newValue = this.count + 1
                if (this.interval > 1) {
                    newValue = newValue + (this.interval - 1)
                }
                if (newValue >= max) newValue = max
            }
            ttCount = this.templateTicketCount()
            if (ttCount < this.templateMin && this.templateMin > 0)
                newValue = Math.max(newValue, this.templateMin);

            let difference = newValue - this.count;
            if (!(totalCount + difference > max && this.codeRequired)) {
                this.count = newValue;
            }
        }
        if (this.count >= this.templateMax) {
          newValue = this.templateMax;
          this.count = this.templateMax;
        }

        if (this.count > 0) {
            this.ticketDescription.removeClass("hidden");
        }

        this.render()
    }
    render() {
        this.num.text(this.count)
        this.setFormInput()
        this.cbUpdate()
    }
    getCount() {
        return this.count
    }
    getType() {
        return this.type
    }
    getMin() {
        let min = +this.min
        if (!min || min < 0) min = 0
        return min
    }
    getMax() {
      let max = +this.max;

        if (max === 0 || !max) max = 10
        return max
    }
    setFormInput() {
        let name = 'ttd_' + this.type
        const codeName = 'code-for_ttd_' + this.type
        const templateName = 'template-for_ttd_' + this.type
        if (this.count > 0) {
            let el = $('#' + name)
            if (el.length > 0) {
                el.val(this.count)
            } else {
                let el = $('<input type="hidden" />')
                el.attr('name', name)
                el.attr('id', name)
                el.val(this.count)
                $('#ticket-form').append(el)
            }
            if (this.code) {
                const el = $('#' + codeName)
                if (el.length > 0) {
                    el.val(this.code)
                } else {
                    const el = $('<input type="hidden" />')
                    el.attr('name', codeName)
                    el.attr('id', codeName)
                    el.val(this.code)
                    $('#ticket-form').append(el)
                }
            }
            if (this.template) {
                const el = $('#' + templateName)
                if (el.length > 0) {
                    el.val(this.template)
                } else {
                    const el = $('<input type="hidden" />')
                    el.attr('name', templateName)
                    el.attr('id', templateName)
                    el.val(this.template)
                    $('#ticket-form').append(el)
                }
            }
        } else {
            $('#' + name).remove()
        }
    }
    toggleDescription() {
        this.ticketDescription.toggleClass('hidden');
    }
}
